export enum MAPBOX_STYLES {
  default = 'default',
  satellite = 'satellite',
}

export const MAPBOX_STYLE_URLS = {
  default: 'mapbox://styles/outdoorsy/cjzmq1m9s115t1crxx83milfw',
  satellite: 'mapbox://styles/outdoorsy/cltq6aa5t005y01p7332sbgzt',
};

export type MapboxStyle = keyof typeof MAPBOX_STYLE_URLS;
